import { call, put, takeLatest, delay } from 'redux-saga/effects';

import { PhoneService } from '../../../entities/Phone/service';
import { VERIFY_PHONE_REQUEST } from './constants';
import { clearStateVerify, isSuccessFalse, verifyPhoneError, verifyPhoneRequest, verifyPhoneSuccess } from './actions';

function* postVerifyPhone(action: ReturnType<typeof verifyPhoneRequest>) {
  try {
    const branchLocal = localStorage.getItem('branchId') || 'null';
    const branchId = JSON.parse(branchLocal)?.id;
    const objNumber = {
      phoneNumber: action.payload,
      messageText: action.code,
      branchId,
    };
    // @ts-ignore
    const data = yield call(PhoneService.verifyPhone, objNumber);
    if (data.success) {
      yield put(verifyPhoneSuccess());
    } else {
      yield put(isSuccessFalse(data.success));
    }
  } catch (error) {
    yield put(verifyPhoneError('Виникла помилка при отриманні коду підтвердження'));
    yield delay(10000);
    yield put(clearStateVerify());
  }
}

export function* verifyPhoneWatcher() {
  yield takeLatest(VERIFY_PHONE_REQUEST, postVerifyPhone);
}
